import { Stack, styled } from '@mui/material'

interface ContentProps {
  children: React.ReactNode
}

export const Content = ({ children, sx }: ContentProps & { sx?: object }) => {
  return <ContentWrapper sx={sx}>{children}</ContentWrapper>
}

const ContentWrapper = styled(Stack)(({ theme }) => ({
  flexDirection: 'column',
  width: '100%',
  padding: theme.spacing(2),
  borderRadius: Number(theme.shape.borderRadius) * 2,
  backgroundColor: theme.palette.background.paper,
}))
